import { endpoints, poster, fetcherGET, fetcher, deleter, patcher, fetcherSwr } from '../utils/axios';
import { useMemo } from 'react';
import useSWR from 'swr';

export function useGetInterpretations(args = {}) {
  const URL = args
    ? [endpoints.interpretations.getInterpretations, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      interpretations: data?.data || [],
      isLoading: isLoading,
      tokenError: error,
      tokenValidating: isValidating,
      // rawResponse: response?.data || {},
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export function useGetInterpretationDetails(args = {}) {
  const URL = args
    ? [endpoints.interpretations.getInterpretationDetails, { params: args }]
    : null;

  const { data, isLoading, error, isValidating } = useSWR(URL, fetcherSwr);

  const memoizedValue = useMemo(
    () => ({
      Interpretation: data?.data || [],
      isLoading: isLoading,
      tokenError: error,
      tokenValidating: isValidating,
      // rawResponse: response?.data || {},
    }),
    [data?.data, error, isLoading, isValidating]
  );

  return memoizedValue;
}
export async function useSetInterpretationInvite(id,args = {}) {
  try {
    const response = await patcher(`${endpoints.interpretations.setInterpretationInvite}${id}`, args);
    return response;
  } catch (error) {
    console.error('createCollection error:', error);
    var response = {};
    response.status = false;

    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
}

export async function useSetCloseInterpretation(id,args = {}) {
  try {
    const response = await deleter(`${endpoints.interpretations.setCloseInterpretation}${id}`, args);
    return response;
  } catch (error) {
    console.error('createCollection error:', error);
    var response = {};
    response.status = false;

    response.message = error?.response?.data?.message ?? error.message;
    return response;;
  }
}